import {
  SpreadsheetDocumentsData,
  parseSpreadsheetDocuments,
} from '../models/SpreadsheetDocument';
import { API_ENDPOINTS } from '../config/api';
import { apiClient } from './api/apiClient';

/**
 * IP / 네트워크 스프레드시트 API 클라이언트 (다중 문서).
 *
 * 백엔드는 projects.network_spreadsheet JSON 컬럼에 통째로 저장(opaque blob).
 * GET 은 미저장/레거시 단일 그리드(`{columns,rows}`)도 받을 수 있어
 * parseSpreadsheetDocuments 가 다중 문서 모양으로 정규화·이관한다.
 */

/** IP/네트워크 기본 컬럼 — 신규 현장 첫 로드 / "빈 문서" seed 에 사용. */
export const DEFAULT_NETWORK_COLUMNS: ReadonlyArray<{ name: string; width: number }> = [
  { name: '카테고리', width: 140 },
  { name: '이름', width: 180 },
  { name: '시작 IP 주소', width: 160 },
  { name: '끝 IP 주소', width: 160 },
  { name: '위치', width: 160 },
  { name: '용도', width: 180 },
  { name: '업데이트 날짜', width: 140 },
];

const NETWORK_DOC_NAME = 'IP / 네트워크';

interface SpreadsheetApiResponse {
  success: boolean;
  message: string;
  data?: unknown;
}

export class NetworkSpreadsheetService {
  static async get(projectId: number): Promise<SpreadsheetDocumentsData> {
    const response = await apiClient.get<SpreadsheetApiResponse>(
      API_ENDPOINTS.SITE_MANAGEMENT.NETWORK_SPREADSHEET.GET(projectId),
    );
    if (!response.data.success) {
      throw new Error(response.data.message || '스프레드시트 조회 실패');
    }
    return parseSpreadsheetDocuments(response.data.data, {
      defaultDocName: NETWORK_DOC_NAME,
      defaultColumns: DEFAULT_NETWORK_COLUMNS,
    });
  }

  static async update(projectId: number, data: SpreadsheetDocumentsData): Promise<void> {
    const response = await apiClient.put<SpreadsheetApiResponse>(
      API_ENDPOINTS.SITE_MANAGEMENT.NETWORK_SPREADSHEET.UPDATE(projectId),
      data,
    );
    if (!response.data.success) {
      throw new Error(response.data.message || '스프레드시트 저장 실패');
    }
  }
}
